import { writable } from "svelte/store";

let stored_token = localStorage.getItem("token");

if (!stored_token) {
    localStorage.setItem("token", "");
    stored_token = localStorage.getItem("token");
}

export const token = writable(stored_token);

token.subscribe(value => {
    console.log(value)
    localStorage.setItem("token", value ? value : '');
});